import React from 'react';
import PropTypes from 'prop-types';
import '../../shared/Card.css';

/* Custom zoom icon from Figma (custom/24/zoom-in, 16×16) */
const ZoomInIcon = require('../../assets/common/icon-zoom-in.svg').ReactComponent;

/**
 * CardZoom — internal to the Configurator cards (PatchCard, TextCard).
 *
 * Figma draws the zoom icon on every card variant. Without `onZoom` it is a
 * decorative hint; with it, it becomes its own button above the card's
 * full-card click target.
 */
const CardZoom = ({ onZoom, label = 'Zoom', className = '' }) => {
  const classes = `ds-card__zoom ${className}`.trim();

  if (!onZoom) {
    return (
      <span className={classes} aria-hidden="true">
        <ZoomInIcon />
      </span>
    );
  }

  return (
    <button type="button" className={classes} onClick={onZoom} aria-label={label}>
      <ZoomInIcon aria-hidden="true" />
    </button>
  );
};

CardZoom.propTypes = {
  /** Zoom click handler — renders the icon as a button */
  onZoom: PropTypes.func,
  /** Accessible name of the zoom button */
  label: PropTypes.string,
  /** Positioning class from the owning card */
  className: PropTypes.string,
};

export default CardZoom;
